import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { domain } from '../common/domain';

function SalesPersons() {
  const [salespersons, setSalespersons] = useState([]);
  const [newSalespersonCode, setNewSalespersonCode] = useState("");
  const [newSalespersonName, setNewSalespersonName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editCode, setEditCode] = useState("");
  const [editName, setEditName] = useState("");

  useEffect(() => {
    fetchSalespersons();
  }, []);

  const fetchSalespersons = async () => {
    try {
      const response = await axios.get(domain() + '?endpoint=salespersons');
      setSalespersons(response.data);
    } catch (error) {
      console.error('Error fetching salespersons:', error);
    }
  };

  const handleAddSalesperson = async () => {
    if (newSalespersonCode.trim() && newSalespersonName.trim()) {
      try {
        const formData = new FormData();
        formData.append('code', newSalespersonCode);
        formData.append('name', newSalespersonName);

        await axios.post(domain() + '?endpoint=salespersons', formData);
        fetchSalespersons();
        setNewSalespersonCode("");
        setNewSalespersonName("");
      } catch (error) {
        console.error('Error adding salesperson:', error);
      }
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${domain()}?endpoint=salespersons&id=${id}`);
      fetchSalespersons();
    } catch (error) {
      console.error('Error deleting salesperson:', error);
    }
  };

  const handleEdit = (id, code, name) => {
    setEditId(id);
    setEditCode(code);
    setEditName(name);
  };

  const handleSave = async (id) => {
    try {
      const formData = new FormData();
      formData.append('code', editCode);
      formData.append('name', editName);
      formData.append('_method', "PUT");
      await axios.post(`${domain()}?endpoint=salespersons&id=${id}`, formData);
      fetchSalespersons();
      setEditId(null);
    } catch (error) {
      console.error('Error updating salesperson:', error);
    }
  };

  return (
    <div className="p-3 bg-light text-dark rounded" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h5 className="mb-3 text-center">Salespersons</h5>
      <div className="d-flex mb-2">
        <input
          type="text"
          className="form-control form-control-sm me-2"
          placeholder="Code"
          value={newSalespersonCode}
          onChange={(e) => setNewSalespersonCode(e.target.value)}
        />
        <input
          type="text"
          className="form-control form-control-sm me-2"
          placeholder="Name"
          value={newSalespersonName}
          onChange={(e) => setNewSalespersonName(e.target.value)}
        />
        <button className="btn btn-sm btn-primary" onClick={handleAddSalesperson}>
          Add
        </button>
      </div>
      <table className="table table-sm table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Code</th>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {salespersons.length > 0 ? (
            salespersons.map((s, index) => (
              <tr key={s.id}>
                <td>{index + 1}</td>
                <td>
                  {editId === s.id ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editCode}
                      onChange={(e) => setEditCode(e.target.value)}
                    />
                  ) : (
                    s.code
                  )}
                </td>
                <td>
                  {editId === s.id ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                    />
                  ) : (
                    s.name
                  )}
                </td>
                <td>
                  {editId === s.id ? (
                    <>
                      <button
                        className="btn btn-sm btn-success me-1"
                        onClick={() => handleSave(s.id)}
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setEditId(null)}
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="btn btn-sm btn-warning me-1"
                        onClick={() => handleEdit(s.id, s.code, s.name)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(s.id)}
                      >
                        Delete
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-muted">
                No salespersons found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SalesPersons;
